<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        冷库温度数据分析
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="timeRange">
            <el-date-picker
              v-model="timeRange"
              type="datetimerange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.comparyIdList">
            <e6Select
              v-model="formExtend.forms.comparyIdList"
              :dataList="comparyTreeList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              multiple
              ref="comparyTreeSelect"
              :placeholder="'公司名称'"
              @multipleSelect="selectCompary"
            ></e6Select>
          </el-form-item>
          <el-form-item prop="forms.storageName">
            <el-input
              v-model="slotForms.forms.storageName"
              placeholder="仓库名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.storageAName">
            <el-input
              v-model="slotForms.forms.storageAName"
              placeholder="库区名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.regisAreas">
            <e6-city
              ref="e6City"
              :placeholder="$GLOBAL_CONFIG.e6City.placeholder"
              class="e6-city"
              @selected="citySelect"
            ></e6-city>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格tab end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
        :span-method="tableSpanMethod"
      >
        <el-table-column
          label="序号"
          width="55"
          align="center"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          min-width="150"
          align="center"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import {
  exportVehicleUseRate,
  FetchColdStorageData
} from "@/api/report/vehicle";

import { FetchAllComparysAndCounty } from "_private/api/systemSetting/userManage";
import { mapActions } from "vuex";
import listInit from "@/mixins/listInit";

import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";
import { exportXlsx } from "@/utils/exportXlsx.js";
import moment from "moment";
import e6City from "e6city";

export default {
  components: { e6City },
  mixins: [listInit, operationManage],
  data() {
    return {
      dataType: "object",
      isSearch: false,
      vehicleList: [], // 车辆下拉数据源
      comparyTreeList: [],
      allStorageInfo: [],
      allStorageAreaInfo: [],
      timeRange: [
        moment()
          .subtract(7, "day")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        moment()
          .subtract(1, "day")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      ],

      formExtend: {
        forms: {
          beginTime: "",
          endTime: "",
          comparyIdList: [],
          storageName: "",
          storageAName: "",
          provinceName: "",
          cityName: "",
          countyName: ""
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      // 表格列相关
      columSetVisible: false,
      multipleSelection: [],
      datePickerOptions: datePickerOptionsNotContainToday,
      // 请求表格数据
      tableDataUrl: "/report/VehicleUsageRate/findByPage",
      //导出URL
      exportUrl: "/report/ReportTempAnalysis/exportList?",
      storeObj: {}
    };
  },
  created() {
    this.initComparyTree();
    this.setSearchFormIsOpenAct();
    this.initPage();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 检验时间40天
    validataTime() {
      let start = moment(this.timeRange[0]);
      let end = moment(this.timeRange[1]);
      //判断时间间隔不能大于40天
      if (end.diff(start, "days") > 39) {
        this.$message.warning("开始时间与结束时间间隔不能大于40天！");
        return false;
      } else {
        return true;
      }
    },
    citySelect(res) {
      if (res.province.name == "澳门") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "香港") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "台湾省") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.city.name;
        this.formExtend.forms.countyName = res.district.name;
      }
    },
    //初始企业信息
    async initComparyTree() {
      try {
        let res = await FetchAllComparysAndCounty();
        if (res.result && Array.isArray(res.result)) {
          this.comparyTreeList = res.result;
        }
      } catch (error) {
        console.log(error);
      }
    },
    selectCompary(val) {
      this.formExtend.forms.comparyIdList = [];
      if (val.length) {
        this.formExtend.forms.comparyIdList = val.map(v => {
          return v.id;
        });
      }
    },

    // 请求列表数据
    getTableData() {
      try {
        return new Promise((resolve, reject) => {
          if (!this.timeRange) {
            this.$message.warning("开始时间与结束时间不能为空！");
            reject();
          }
          if (this.validataTime()) {
            FetchColdStorageData(this.mergeObj())
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          } else {
            this.tableLoading = false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 设置表格内容数据
    setTableData(response) {
      if (
        response.result &&
        response.result.data &&
        Array.isArray(response.result.data)
      ) {
        this.tableData = response.result.data;
        this.total = response.result.totalRecords;
        this.storeObj = {};
        this.tableData.forEach((v, i) => {
          if (i == 0) {
            v.merge = true;
          } else {
            if (v.storageAId == this.tableData[i - 1].storageAId) {
              v.merge = false;
            } else {
              v.merge = true;
            }
          }
          // 仓库合并数目对象
          if (this.storeObj[v.storageAId]) {
            this.storeObj[v.storageAId].count++;
          } else {
            this.storeObj[v.storageAId] = new Object();
            this.storeObj[v.storageAId].count = 1;
          }
        });
      }
      this.tableLoading = false;
    },
    // 合并列
    tableSpanMethod({ row, columnIndex }) {
      if (
        columnIndex === 1 ||
        columnIndex === 2 ||
        columnIndex === 3 ||
        columnIndex === 4
      ) {
        if (row.merge) {
          return {
            rowspan: this.storeObj[row.storageAId].count,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 整合查询数据
    mergeObj() {
      if (this.timeRange) {
        this.formExtend.forms.beginTime = this.timeRange[0];
        this.formExtend.forms.endTime = this.timeRange[1];
      } else {
        this.formExtend.forms.beginTime = "";
        this.formExtend.forms.endTime = "";
      }
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // 导出excel 表格
    handleExport() {
      if (this.validataTime()) {
        let params = this.mergeObj();
        this.exportData(params);
      }
    },
    // 导出页面数据接口请求
    async exportData(params) {
      try {
        exportVehicleUseRate(params).then(res => {
          // 导出
          exportXlsx(res, `装卸货分析报表.xls`);
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 重置
    handleResetForm() {
      this.timeRange = [
        moment()
          .subtract(7, "day")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        moment()
          .subtract(1, "day")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      ];
      this.$refs.e6City.clearCity();
      this.formExtend.forms.cityId = "";
      this.formExtend.forms.provinceId = "";
      this.formExtend.forms.countyName = "";
      this.formExtend.forms.cityName = "";
      this.formExtend.forms.provinceName = "";
      this.$refs.comparyTreeSelect.multipleRemoveAll();
      this.formExtend.forms.comparyIdList = [];
    },
    //导出
    handleExportClick() {
      let param = "";
      if (this.timeRange !== null && this.timeRange !== "") {
        param += "&beginTime=" + this.timeRange[0];
        param += "&endTime=" + this.timeRange[1];
        param += "&comparyIdList=" + this.formExtend.forms.comparyIdList;
        param += "&storageName=" + this.formExtend.forms.storageName;
        param += "&storageAName=" + this.formExtend.forms.storageAName;
        param += "&provinceName=" + this.formExtend.forms.provinceName;
        param += "&cityName=" + this.formExtend.forms.cityName;
        param += "&countyName=" + this.formExtend.forms.countyName;
        document.location.href = this.exportUrl + param;
      } else {
        this.$message({
          showClose: true,
          message: "开始时间与结束时间不能为空！",
          type: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
.total_tab {
  display: flex;
  align-items: center;
  height: 100%;
  p {
    margin: 0 10px;
    color: #aaa;
    span {
      color: #333;
      margin-left: 10px;
    }
  }
}
</style>
